import React, { useEffect, useState, useRef } from 'react'
import { Worker } from '@react-pdf-viewer/core';
import { Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import { ProgressBar } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import { MediaPlayer, MediaProvider, Poster } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import UserQuiz from '../user/userQuiz/UserQuiz'
import TimerTracker from '../../../utils/tracker';
// import { PptxViewer } from 'react-pptx-viewer';


export const LMSPlayVideo = ({ playerContent, onUpdate }) => {

  const [duration, setDuration] = useState(0);
  const [playbackPercentage, setPlaybackPercentage] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [inactiveTab, setInactiveTab] = useState(false);
  let mounted = true;
  const mediaPlayerRef = useRef(null);
  const playbackPercentageRef = useRef(playbackPercentage); // <--- add a ref to store the current value

  const updateTrackingData = (time) => {
    onUpdate({
      id: playerContent.uuid,
      progress: time
    });
  }

  const handleTimeUpdate = (event) => {
    let _currentTime = event.currentTime;
    if (duration > 0) {
      let completeProgress = Math.floor((_currentTime / duration) * 100);
      setPlaybackPercentage(completeProgress);
      playbackPercentageRef.current = completeProgress;
    }
  };

  const handleLoadedMetadata = (event) => {
    updateTrackingData(playbackPercentage);
    setDuration(Math.floor(event.target.duration));
  };

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
    isPlaying && updateTrackingData(playbackPercentage);
  };

  useEffect(() => {
    if (inactiveTab) {
      mediaPlayerRef.current.pause();
    }
  }, [inactiveTab]);


  useEffect(() => {
    return () => {
      if (mounted) {
        mounted = false
      } else {
        updateTrackingData(playbackPercentageRef.current);
      }
    };
  }, []);


  return (
    <>
      <div className="quiz main-quiz-body d-flex">
        <MediaPlayer
          title="Course Introduction"
          ref={mediaPlayerRef}
          src={playerContent?.assetLink}
          onTimeUpdate={(event) => handleTimeUpdate(event)}
          onLoadedMetadata={(event) => handleLoadedMetadata(event)}
          onPause={handlePlayPause}
          onPlay={handlePlayPause}
        >

          <MediaProvider >
            {/* <Poster src={defaultLogo} /> */}
          </MediaProvider >
          <DefaultVideoLayout
            // thumbnails={defaultLogo} 
            icons={defaultLayoutIcons}
            slots={{
              qualityMenu: defaultLayoutIcons.quality,
              pipButton: () => null,
              googleCastButton: () => null,
            }}
          />

        </MediaPlayer>

      </div>

      <TimerTracker setInactiveTab={setInactiveTab} />

    </>
  )
}


export const LMSPlayQuiz = ({ playerContent, onUpdate }) => {
  const [qusList, setQusList] = useState([]);

  useEffect(() => {
    if (playerContent.questions) {
      let qusData = playerContent.questions;

      const shuffleArray = (array) => {
        for (let i = array?.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
      }
      shuffleArray(qusData);

      qusData.forEach((item) => {
        if (item.options) {
          shuffleArray(item.options);
        }
      });
      setQusList([...qusData]);

    }
  }, [playerContent]);


  const update2DQuizSession = (data) => {
    let rightPercentage = Math.floor((data.totalRightWeightAge * 100) / data.totalWeightAge)
    onUpdate({
      id: playerContent.uuid,
      progress: rightPercentage
    });
  }



  return (
    <UserQuiz qusList2D={qusList} UUID2D={playerContent?.uuid} update2DQuizSession={update2DQuizSession} />
  )
}


export const LMSPlayPDF = ({ playerContent, onUpdate }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const transform = (slot) => ({
    ...slot,
    Download: () => <></>,
    DownloadMenuItem: () => <></>,
    // EnterFullScreen: () => <></>,
    // EnterFullScreenMenuItem: () => <></>,
    SwitchTheme: () => <></>,
    SwitchThemeMenuItem: () => <></>,
    Open: () => <></>,
    Print: () => <></>,
    ShowProperties: () => <></>,
    ShowPropertiesMenuItem: () => <></>,
    // ZoomIn: () => <></>,
    // ZoomOut: () => <></>,
  });
  const toolbarPluginInstance = toolbarPlugin();
  const { renderDefaultToolbar } = toolbarPluginInstance;
  const renderToolbar = (Toolbar) => (
    <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: (defaultTabs) => [
      defaultTabs[0],
    ],
  });


  const handleLoadSuccess = (event) => {
    onUpdate({
      id: playerContent.uuid,
      progress: 100
    });
  };
  const handleOnPageChange = (event) => {
    setCurrentPage(event.currentPage + 1);
  };

  return (
    <div className="quiz main-quiz-body">
      <Worker workerUrl="https://cdn.simulanis.io/sso/external/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <Viewer
          fileUrl={playerContent?.assetLink}
          plugins={[defaultLayoutPluginInstance]}
          onDocumentLoad={(event) => handleLoadSuccess(event)}
          renderLoader={(percentages) => (
            <div className='spin-parent'>
              <div className='spinn-load'>
                <svg viewBox="25 25 50 50">
                  <circle r="20" cy="50" cx="50"></circle>
                </svg>
              </div>
            </div>
          )}
        // onPageChange={(e)=>handleOnPageChange(e)
        // initialPage={0}
        />
      </Worker>
    </div>
  )
}


export const LMSPlayPPT = ({ playerContent, onUpdate }) => {
  const [loading, setLoading] = useState(true);


  const handleIframeLoad = () => {
    setLoading(false)
    onUpdate({
      id: playerContent.uuid,
      progress: 100
    });
  }


  return (

    <div className="quiz main-quiz-body">
      {loading && (
        <div className='frame-parent'>
          <div className='spin-parent'>
              <div className='spinn-load'>
                <svg viewBox="25 25 50 50">
                  <circle r="20" cy="50" cx="50"></circle>
                </svg>
              </div>
            </div>
        </div>
      )}
      <iframe
        src={`https://docs.google.com/viewer?url=${playerContent?.assetLink}&embedded=true`}
        width="100%"
        height="100%"
        onLoad={() => handleIframeLoad()}
        style={{ display: loading ? "none" : "block" }}
      ></iframe>
    </div>
  );

}